import { render, staticRenderFns } from "./BannerGroupList.vue?vue&type=template&id=035e4744&scoped=true&"
import script from "./BannerGroupList.vue?vue&type=script&lang=js&"
export * from "./BannerGroupList.vue?vue&type=script&lang=js&"
import style0 from "./BannerGroupList.vue?vue&type=style&index=0&id=035e4744&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035e4744",
  null
  
)

export default component.exports